<template>
  <section class="about-cta position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>
    
    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="cta-content text-center">
            <div class="cta-title">
              <h2>{{ content.title }}</h2>
            </div>
            <div class="cta-description">
              <p>{{ content.description }}</p>
            </div>
            <div class="cta-buttons">
              <router-link v-for="(button, index) in content.buttons" :key="index" :to="button.link" :class="['cta-btn', button.type]">
                <i :class="button.icon"></i> {{ button.text }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutCtaComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-1 {
  top: 10%;
  right: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  bottom: 20%;
  left: 8%;
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-3 {
  top: 30%;
  left: 10%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-4 {
  top: 15%;
  right: 15%;
  width: 90px;
  height: 90px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

/* Call to Action Section */
.about-cta {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.cta-content {
  position: relative;
  z-index: 2;
}

.cta-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.cta-description p {
  font-size: 18px;
  color: #fff;
  max-width: 600px;
  margin: 0 auto 40px;
  line-height: 1.8;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.primary-btn {
  background: linear-gradient(135deg, #F6EC4F, #E6D43A);
  color: #00061A;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(246, 236, 79, 0.3);
}

.secondary-btn {
  background: transparent;
  color: #F6EC4F;
  border-color: #F6EC4F;
}

.secondary-btn:hover {
  background: #F6EC4F;
  color: #00061A;
  transform: translateY(-2px);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .about-cta {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .about-cta {
    padding: 60px 0;
  }
  
  .cta-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}

@media only screen and (max-width: 399px) {
  .about-cta {
    padding: 40px 0;
  }
  
  .cta-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
